<template>
  <div class="app-container">
    <list ref="list" :can-price="$permission.canPrice()">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button v-if="$permission.canWrite() && row.Status !== 2" @click="edit(row)" type="text" >
              编辑
            </el-button>
            <el-button v-if="$permission.canReview() && row.Status == 2"   type="text" @click="edit(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/ticketmanagement/workshopprofit/list'


export default {
  name: "workshopprofit",
  mixins: [curdMixins],
  components: { 
    list,
  },
  data(){
    return {
      api: require("@/api/pr/workshopprofit").default,
    }
  },
  methods: {
    edit({ProfitLossId}){
       let id = ProfitLossId;
       this.api.info(id).then(res => {
        if(res.Code === 0){
          this.toURL({
            name: 'editworkshopprofit',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
       })

       
    },
    create(){
      
      this.toURL({
        name: 'editworkshopprofit',
        params: {
          type: 'create'
        }
      })

    },
    toURL(o){
      this.$router.push(o)
    }
  }
  
};
</script>